import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=5b2bab19&scoped=true&"
import script from "./LogoutButton.ts?vue&type=script&lang=ts&"
export * from "./LogoutButton.ts?vue&type=script&lang=ts&"
import style0 from "./LogoutButton.scss?vue&type=style&index=0&id=5b2bab19&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2bab19",
  null
  
)

export default component.exports